import { MenuItem, Select, Typography } from "@mui/material";
import { useState } from "react";
import Modal from "../ui/Modal";
import { useSnackbar } from "notistack";
import FormItem from "../ui/FormItem";

const MarkAttendance = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const mark = () => {
    props.close();
  };
  return (
    <Modal
      {...props}
      title="Mark attendance for class ..."
      actionText="Mark Attendance"
      loading={loading}
      action={mark}
    >
      <FormItem label="Attendance Status">
        <Select
          name="status"
          value={"PRESENT"}
          //onChange={handleChange}
          fullWidth
        >
          <MenuItem value="PRESENT">Present</MenuItem>
          <MenuItem value="ABSENT">Absent</MenuItem>
        </Select>
      </FormItem>
    </Modal>
  );
};

export default MarkAttendance;
